import { createReducer, on } from '@ngrx/store';
import { CartPageState } from '../../models/custom-cart.model';
import { ErrorModel } from '@spartacus/core';
import { CartPageActions } from '../Actions';

export const initialState: CartPageState = {
  loading: null,
  success: null,
  error: null,
  cartProductsData: null,
  cartCoupon: [],
  appliedCoupon: null,
};

export const CartPageReducer = createReducer(
  initialState,
  // Reducer to return the total products for that cart
  on(CartPageActions.loadCartProductsSuccess, (state: CartPageState, { cartProductsData }): CartPageState => ({
    ...state,
    cartProductsData,
    loading: false,
    success: true,
    error: null,
    appliedCoupon: cartProductsData?.appliedVouchers?.[0]?.code || null,
  })),
  on(CartPageActions.loadCartProductsFailure, (state: CartPageState, { error }): CartPageState => ({
    ...state,
    loading: false,
    success: false,
    error: { message: error } as ErrorModel
  })),

  // Reducer to Update Product quantity in that cart
  on(CartPageActions.updateProductQtySuccess, (state: CartPageState, { updatedCartProducts }): CartPageState => ({
    ...state,
    loading: false,
    success: true,
    cartProductsData: {
      ...state.cartProductsData,
      cartProductsInfo: state.cartProductsData?.cartProductsInfo || [],
      updatedProductsQty: updatedCartProducts,
    },
    error: null
  })),
  on(CartPageActions.updateProductQtyFailure, (state: CartPageState, { error }): CartPageState => ({
    ...state,
    loading: false,
    success: false,
    error: { message: error } as ErrorModel
  })),

  // Reducer to Update after click to proceed checkout page.
  on(CartPageActions.postToCheckoutSuccess, (state: CartPageState, { response }): CartPageState => ({
    ...state,
    loading: false,
    success: true,
    cartProductsData: {
      ...state.cartProductsData,
      cartProductsInfo: state.cartProductsData?.cartProductsInfo || [],
      checkoutResponse: response,
    },
    error: null,
  })),
  on(CartPageActions.postToCheckoutFailure, (state: CartPageState, { error }): CartPageState => ({
    ...state,
    loading: false,
    success: false,
    error: { message: error } as ErrorModel
  })),

  on(CartPageActions.clearCartState, () => ({ ...initialState })),

  //Customer Apply Coupon
  on(CartPageActions.loadCustomerCoupon, (state): CartPageState => ({
    ...state,
    loading: true,
    success: false,
    error: null,
  })),
  on(CartPageActions.loadCustomerCouponSuccess, (state, { cartCouponData }): CartPageState => ({
    ...state,
    cartCoupon: cartCouponData,
    loading: false,
    success: true,
    error: null,
  })),
  on(CartPageActions.loadCustomerCouponFailure, (state, { error }): CartPageState => ({
    ...state,
    loading: false,
    success: false,
    error: { message: error } as ErrorModel,
  })),
  on(CartPageActions.applyCoupon, (state): CartPageState => ({
    ...state,
    loading: true,
    success: false,
    error: null,
  })),
  on(CartPageActions.applyCouponSuccess, (state, { voucherId }): CartPageState => ({
    ...state,
    appliedCoupon: voucherId,
    loading: false,
    success: true,
    error: null,
  })),
  on(CartPageActions.applyCouponFailure, (state, { error }): CartPageState => ({
    ...state,
    loading: false,
    success: false,
    error: { message: error } as ErrorModel,
  })),
  on(CartPageActions.removeCoupon, (state): CartPageState => ({
    ...state,
    loading: true,
    success: false,
    error: null,
  })),
  on(CartPageActions.removeCouponSuccess, (state): CartPageState => ({
    ...state,
    appliedCoupon: null,
    loading: false,
    success: true,
    error: null,
  })),
  on(CartPageActions.removeCouponFailure, (state, { error }): CartPageState => ({
    ...state,
    loading: false,
    success: false,
    error: { message: error } as ErrorModel,
  })),
);